import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../../components/ui/Header';
import Breadcrumb from '../../../components/ui/Breadcrumb';
import DeploymentPointModal from './DeploymentPointModal';
import Button from '../../../components/ui/Button';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import DataTable from 'react-data-table-component';
import Select from '../../../components/ui/Select';
import SectortModal from './SectorModal';

const SectorPage = () => {
 
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterOption, setFilterOption] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');
const [sectorOptions, setSectorOptions] = useState([]);
const [dataTableData,setDataTableValue] = useState([])
 const [originalData, setOriginalData] = useState([]);


  useEffect(() => {
    getSectorValue();
  }, []);

   const getSectorValue = async () => {
    try {
      const data = await httpHelper(URL_CONSTANTS.GET_SECOTR_VALUES, Method_TYPE.GET);
      console.log("Sector values:", data);

      const formattedTableData =  data?.data?.map((sector, index) => ({
        slno: index + 1,
        value: sector?._id,
        sector: sector?.name,
      }));

      setOriginalData(formattedTableData);         // Save full list for filtering
      setDataTableValue(formattedTableData)
      // Correctly map the sector data to options
      setSectorOptions(
        data?.data?.map((sector) => ({
          value: sector?._id,
          label: sector?.name,
        })) || []
      );
      //  setDataTableValue(
      //   data?.data?.map((sector,index) => ({
      //       slno:index+1,
      //     value: sector?._id,
      //     sector: sector?.name,
      //   })) || []
      // );
       setFilterOption(data?.data?.map((tableData) =>({
        label: tableData?.name,
         value: tableData?._id,
    })));
    } catch (err) {
      console.error('Error fetching sector values:', err);
      setSectorOptions([]);
    }
  };

  console.log("filter value",filterOption)
  const handleAddNew = () => {
    setSelectedPoint(null);
    setIsModalOpen(true);
  };
const handleEdit = (row) => {
console.log("vahh123",row,dataTableData)
  let editValue = originalData?.filter(detail=> detail?.value === row)
  console.log("vvvv123",editValue)
  setSelectedPoint(editValue);
  setIsModalOpen(true);
};

 const handleFilter = (e) => {
    console.log("filter ",e)
  setFilterStatus(e);
  const filtered = e
    ? originalData.filter(detail => detail.value === e)
    : originalData;
console.log(filtered,originalData,"handleFilter")
  setDataTableValue(filtered);
};

const columns = [
  {name: 'Sl.No',selector: row => row.slno,sortable: true,cell: row => <div data-title="Sl.No">{row.slno}</div>,},
  {name: 'Sector',selector: row => row.sector,sortable: true,cell: row => <div data-title="Sector">{row.sector}</div>,},
  {name: 'Actions',cell: row => (
      <div data-title="Actions">
        <Button
          variant="ghost"
          size="sm"
          iconSize="16"
          onClick={() => handleEdit(row.value)}
          iconName="Edit"
          iconPosition="left"
          >
          <span className='inline-block lg:inline-block'>Edit</span>                  
        </Button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
];

  // Filter deploymentDetails based on filterStatus
 

  return (
    <>
      <div className="p-4 text-center border-border bg-white bg-card border !rounded-lg shadow-spiritual-sm border-b-0 !rounded-bl-none !rounded-br-none relative">
        <div className="flex justify-between mb-0 md:flex-row flex-col">
         <Select
  placeholder="Filter by Sector"
  options={filterOption} // use directly
  value={filterStatus}
  onChange={(e) => handleFilter(e)}
/>
          <div className='flex mt-2 md:mt-0 justify-end'>
            <button type='button' className='inline-flex md:h-full mr-4 w-36 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-gray-500 hover:text-white text-white rounded-md bg-gray-400 px-3' 
          onClick={getSectorValue}>Refresh</button>
          <button type='button' className='hover:text-accent-foreground w-36 max-w-32 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2'
           onClick={handleAddNew}>Add</button>
          </div>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={dataTableData}
        fixedHeader
        fixedHeaderScrollHeight='500px'
        defaultSortFieldId={1}
          className='reports-table'
      />
      <SectortModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedPoint={selectedPoint}
        getSectorValue= {getSectorValue}
        sectorOptions= {sectorOptions}
      />

    </>
  );
};

export default SectorPage;
